export * from './components/Breadcrumbs/breadcrumbs.ts'
export * from './components/Drawer/drawer.ts'
export * from './components/Header/header.ts'
export * from './components/Icon/icon.ts'
export * from './components/LabelToggle/label-toggle.ts'
export * from './design/animation.ts'
export * from './design/jump-links.ts'
export * from './components/Footer/footer.ts'
export * from './components/Popover/popover.ts'
export * from './components/ProductDetail/product-detail.ts'
export * from './components/Tabs/tabs.ts'
export * from './components/ProductSlider/product-slider.ts'
export * from './components/Video/video.ts'
export * from './components/Form/form.ts'
export * from './components/ContentSlider/content-slider.ts'
export * from './components/ReadMore/read-more.ts'
export * from './components/Search/search.ts'
export * from './components/Accordion/accordion.ts'
export * from './components/YouTubeEmbed/you-tube-embed.ts'
export * from './components/Combobox/combobox.ts'
export * from './components/NumberInput/number-input.ts'
export * from './components/UspSlider/usp-slider.ts'
export * from './components/FileInput/file-input.ts'
export * from './components/TextArea/text-area.ts'
export * from './components/Table/table.ts'
export * from './components/ImageSlider/image-slider.ts'

export function isSafari(): boolean {
  const ua = navigator.userAgent
  const isIOS = /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  const isSafari = /Safari/.test(ua) &&
    !/Chrome|Chromium|Edg|OPR|Opera/.test(ua)

  if (isIOS || isSafari) {
    document.documentElement.classList.add('is-safari')
  }

  return isIOS || isSafari
}

export function debounce<T extends (...args: any[]) => any>(fn: T, ms: number) {
  let timer: ReturnType<typeof setTimeout>
  return (...args: Parameters<T>) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), ms)
  }
}
